export const categoryPic: { [key: string]: string } = {
  319809: `https://faradars.org/wp-content/uploads/2024/10/08/category-319809.svg`,
  235656:
    "https://faradars.org/wp-content/uploads/2024/10/08/category-235656.svg",
  1049: "https://faradars.org/wp-content/uploads/2024/10/08/category-1049.svg",
  233937:
    "https://faradars.org/wp-content/uploads/2024/10/08/category-233937.svg",
  333181:
    "https://faradars.org/wp-content/uploads/2024/10/08/category-333181.svg",
  54236:
    "https://faradars.org/wp-content/uploads/2024/10/08/category-54236.svg",
  333230:
    "https://faradars.org/wp-content/uploads/2024/10/08/category-333230.svg",
  333213:
    "https://faradars.org/wp-content/uploads/2024/10/08/category-333213.svg",
  333209:
    "https://faradars.org/wp-content/uploads/2024/10/08/category-333209.svg",
  333220:
    "https://faradars.org/wp-content/uploads/2024/12/04/category-333220.svg",
  333221:
    "https://faradars.org/wp-content/uploads/2024/10/09/category-333221.svg",
};
